/* eslint-disable react/jsx-no-target-blank */
import {KTIcon} from '../../../helpers'
import {ClearCash} from "../../../../app/pages/BaseConfig/core/_requests";
import {SwalClose, SwalError, SwalLoading} from "../../../helpers/components/Swal";
import {useAuth} from "../../../../app/modules/auth";

const SidebarFooter = () => {
    const {currentUser} = useAuth();
    const ClearCashed = ()=>{
        const bind = async ()=>{
            try {
                SwalLoading()
                await ClearCash()
                SwalClose()
            }catch (err:any){
                SwalClose()
                SwalError(err!.response!.data!.message)
            }
        }
        bind()
    }
  return (
    <div className='app-sidebar-footer flex-column-auto pt-2 pb-6 px-6' id='kt_app_sidebar_footer'>
        {
            currentUser?.roles?.includes('Admin' || 'Partner') && (
                <a

                    className='btn btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100'
                    data-bs-toggle='tooltip'
                    data-bs-trigger='hover'
                    data-bs-dismiss-='click'
                    title='پاک کردن کشش سیستم'
                    onClick={ClearCashed}
                >
                    <span className='btn-label'>پاک کشش سیستم</span>
                    <KTIcon iconName='document' className='btn-icon fs-2 m-0' />
                </a>
            )
        }

    </div>
  )
}

export {SidebarFooter}
